import { useQuery } from '@tanstack/react-query';
import hrmsService, { hrmsKeys } from '@/services/hrms.service';
import { isIndiaHrmsPack } from '@/pages/hr/shared/hrmsPolicyOptions';

/**
 * Company HRMS policy map + India pack flag.
 * Reuses hrmsKeys.policy / getPolicy — same source as HRMS Setup.
 */
export function useHrmsPolicy() {
  const query = useQuery({
    queryKey: hrmsKeys.policy(),
    queryFn: () => hrmsService.getPolicy(),
    staleTime: 60_000,
  });

  const policy = query.data || {};
  const pack = policy['hrms.policy_pack'];
  const indiaPack = isIndiaHrmsPack(pack);

  return {
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    policy,
    pack,
    indiaPack,
    defaultPayrollCurrency: indiaPack ? 'INR' : 'AED',
    refetch: query.refetch,
  };
}
